import React from "react";

const ADIExclusivelogo = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="26" height="11" viewBox="0 0 26 11">
        <defs>
            <path id="dq62l82sva" d="M0 0.054L17.681 0.054 17.681 10.211 0 10.211z"/>
        </defs>
        <g fill="none" fill-rule="evenodd">
            <g>
                <g>
                    <path fill="#000" d="M22.392 0L21.648 2.052 21.648 10.133 24.181 10.133 24.181 0 22.392 0M18.21.46l-.97 2.446h-.001c.812.41 1.298 1.197 1.298 2.285v.03c0 1.093-.48 1.874-1.286 2.283-.42.213-.932.325-1.509.325h-.457l-1.006 2.534h1.362c3.648 0 5.777-2.21 5.777-5.186v-.03c0-2.2-1.148-3.932-3.208-4.686" transform="translate(.23)"/>
                    <g transform="translate(.23)">
                        <mask id="t58modjzpb" fill="#fff">
                            <use xlinkHref="#dq62l82sva"/>
                        </mask>
                        <path fill="#000" d="M14.695 7.715V2.55h1.133c.323 0 .626.036.903.106l.95-2.378c-.574-.146-1.207-.224-1.896-.224h-3.873v10.157h1.802l.98-2.496M7.146.055L4.418.055 4.417.055 0 10.211 2.923 10.211 7.146.055" mask="url(#t58modjzpb)"/>
                    </g>
                    <path fill="#000" d="M7.488 0.921L4.376 8.555 7.733 8.555 8.478 10.363 11.515 10.363 7.488 0.921" transform="translate(.23)"/>
                </g>
            </g>
        </g>
    </svg>
    )
}

export default ADIExclusivelogo;